<template>
    <div id="mainContainer">
        
        <div class="videoContainer">
            <div v-for="video in videos" >
                <app-video v-bind:video="video"></app-video>
            </div>
        </div>
    </div>
</template>
<script>
    import Video from '@/components/Video'

    export default {
        name: 'videos-list',
        props: ['videos'],
        components: {
            'app-video': Video,
        }
    }
</script>
<style>
#mainContainer
{
    width:100%;
    display: flex;  
    justify-content: center;  
}
.videoContainer
{
    min-width:840px;
    display: flex;  
    justify-content: center;  
	flex-wrap : wrap ; 
    
}

</style>



// WEBPACK FOOTER //
// VideosList.vue?2a32547a